import { Box, ListItem, AHIcon, AHSeparator } from "arkh";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { TodoMainContent } from "../WorkspaceTodoEdit/WorkspaceTodoEditMain/WorkspaceTodoEditMainContent";
import { ExpireSelector } from "../WorkspaceTodoEdit/WorkspaceTodoEditMain/WorkspaceTodoEditMainExpireSelector";
import { TodoPrioritySelector } from "../WorkspaceTodoEdit/WorkspaceTodoEditMain/WorkspaceTodoEditMainPrioritySelector";
import { WorkspaceTodoEditMainProducts } from "../WorkspaceTodoEdit/WorkspaceTodoEditMain/WorkspaceTodoEditMainProducts";
import { WorkspaceTodoEditMainPushNotification } from "../WorkspaceTodoEdit/WorkspaceTodoEditMain/WorkspaceTodoEditMainPushNotification";
import { WorkspaceTodoEditMainResponseType } from "../WorkspaceTodoEdit/WorkspaceTodoEditMain/WorkspaceTodoEditMainResponseType";
import { WorkspaceTodoDetailScreenHeader_todoWorkspace$key } from "./__generated__/WorkspaceTodoDetailScreenHeader_todoWorkspace.graphql";

export function WorkspaceTodoDetailScreenHeader(props: {
  todoWorkspace: WorkspaceTodoDetailScreenHeader_todoWorkspace$key;
  workspaceId: string;
  hasProductsFeature: boolean;
  openProduct: (id: string) => void;
}) {
  const intl_tokens = useIntlTokens();
  const todoWorkspace = useFragment(
    graphql`
      fragment WorkspaceTodoDetailScreenHeader_todoWorkspace on TodoWorkspace {
        ...WorkspaceTodoEditMainContent_Todo
        ...WorkspaceTodoEditMainProducts_TodoWorkspace
        ...WorkspaceTodoEditMainExpireSelector_Todo
        ...WorkspaceTodoEditMainPrioritySelector_Todo
        ...WorkspaceTodoEditMainResponseType_TodoWorkspace
        ...WorkspaceTodoEditMainPushNotification_todoWorkspace
      }
    `,
    props.todoWorkspace
  );
  return (
    <>
      <Box
        style={{
          flexDirection: "row",
          width: "100%",
          alignSelf: "center",
        }}
        spaceBottom="large"
        spaceTop="medium"
      >
        <Box style={{ width: "55%" }} spaceRight="small">
          <TodoMainContent
            todo={todoWorkspace}
            workspaceId={props.workspaceId}
            disabled
          />
        </Box>
        <Box style={{ width: "45%" }} spaceLeft="small">
          {props.hasProductsFeature ? (
            <Box spaceBottom="medium">
              <WorkspaceTodoEditMainProducts
                todo={todoWorkspace}
                disabled
                openProduct={(id) => {
                  props.openProduct(id);
                }}
              />
            </Box>
          ) : null}
          <ListItem
            disabled
            color="transparent"
            border="border-primary"
            isFirst
            left={<AHIcon type="deadline" color="darkText" />}
            right={<ExpireSelector disabled todo={todoWorkspace} />}
          >
            <ListItem.TitleSecondary>
              {intl_tokens.Deadline}
            </ListItem.TitleSecondary>
          </ListItem>
          <AHSeparator />
          <ListItem
            disabled
            color="transparent"
            border="border-primary"
            left={<AHIcon type="prio" color="darkText" />}
            right={<TodoPrioritySelector disabled todo={todoWorkspace} />}
            isLast
          >
            <ListItem.TitleSecondary>
              {intl_tokens.Priority}
            </ListItem.TitleSecondary>
          </ListItem>

          <Box spaceTop="medium">
            <WorkspaceTodoEditMainResponseType disabled todo={todoWorkspace} />
          </Box>
          <Box spaceTop="medium">
            <WorkspaceTodoEditMainPushNotification
              disabled
              todoWorkspace={todoWorkspace}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}
